import { render, staticRenderFns } from "./InstancesList.vue?vue&type=template&id=55d64ee4"
import script from "./InstancesList.vue?vue&type=script&lang=js"
export * from "./InstancesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports